import React, { forwardRef, useImperativeHandle } from 'react';
import { CKEditor } from 'ckeditor4-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
const CKEditorCSSHack = styled.div`
  flex: 1 0;
  width: 24cm;
  & .cke_inner{
    display:flex;
    flex-flow:column;
    height:100%;
    > .cke_contents{
        flex: 1 0;
    }
  }
`
// ovenstående css er et massivt hack uden om ckeditoren react komponent.


const Editor = forwardRef((p : { initialText: string, onInputChange: (e: string) => void, handInId: string}, ref) => {
    const { i18n } = useTranslation();

    const onChange = (data: any) => {
        p.onInputChange(data.editor.getData());
    }

    useImperativeHandle(ref, () => ({
        scrollHeaderIntoView(headerIndex: number) {
            const iframe = document.querySelector("iframe.cke_wysiwyg_frame");
            const headings = (iframe as HTMLIFrameElement).contentDocument?.querySelectorAll("h1, h2, h3, h4, h5, h6");
            const heading = headings != null ? headings[headerIndex] : null;
            
            heading?.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
        },
        insertImage(imagePath: string) {
            const w: any = window;// Dette får type script til at glemme at window er Window objektet og ikke sige fejl på næste linie.
            w.CKEDITOR.instances.editor1.insertHtml('<img src="' + imagePath + '"/>');
        },
        replaceImage(oldImagePath: string, newImagePath: string) {
            const w: any = window;// Dette får type script til at glemme at window er Window objektet og ikke sige fejl på næste linie.
            var n = w.CKEDITOR.instances.editor1.document.find("img[src='" + oldImagePath + "']");
            if (n.count() > 0) {
                for (var i = 0; i < n.count(); i++) {
                    var img = n.getItem(i).$;
                    img.src = newImagePath;
                    img.setAttribute("data-cke-saved-src", newImagePath);
                }

                w.CKEDITOR.instances.editor1.fire('change');
            }
        }
    }));

    return (
        <CKEditorCSSHack>
        <CKEditor
            config={{
                'toolbar': [
                    { name: 'document'},
                    { name: 'clipboard', items: ['Undo', 'Redo'] },
                    { name: 'styles', items: ['Format'] },
                    {
                        name: 'basicstyles',
                        items: ['Bold', 'Italic', 'Underline', 'RemoveFormat']
                    },
                    {
                        name: 'X',
                        items: ['Superscript', "Subscript"]
                    },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                    {
                        name: 'paragraph',
                        items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote']
                    },
                    { name: 'insert', items: ['Table', 'Image', 'pbckcode', 'Mathjax','Scayt' ] },
                    ],
                scayt_customerId: 'x60xqEnTZ79whrm',
                scayt_autoStartup : true,
                grayt_autoStartup : true,
                scayt_sLang: "da_DK",
                scayt_uiTabs: '1,1,0', // Skjul bruger ordbog tabben.
                format_tags: 'p;h1;h2;h3;pre',
                filebrowserBrowseUrl: '/imagebrowser/' + p.handInId,
                customConfig: '',
                contentsCss: ['/css/CKEditorIFrame.css'],
                bodyClass: 'document-editor',
                removePlugins: 'elementspath, resize',
                disableNativeSpellChecker: true,
                language: i18n.language,
                contentsLanguage: i18n.language,
                height: "auto",
                extraAllowedContent: {pre: "[*]{*}(*)", img: { attributes: ['!src', 'alt', 'width', 'height'] }, },
                extraPlugins: "pbckcode,mathjax",
                mathJaxLib: 'https://cdn.arcanic.dk/cdn/libs/mathjax/2.7.3/MathJax.js?config=TeX-AMS_HTML',
                pbckcode : {
                    js:"https://cdn.arcanic.dk/cdn/libs/ace/1.2.2/src-min-noconflict",
                    // An optional class to your pre tag.
                    cls: '',

                    // The syntax highlighter you will use in the output view
                    highlighter: 'HIGHLIGHT',
                    /*
                    'HIGHLIGHT' // http://highlightjs.org/
                    'PRETTIFY' // https://code.google.com/p/google-code-prettify/
                    'PRISM' // http://prismjs.com/
                    'SYNTAX_HIGHLIGHTER' // http://alexgorbatchev.com/SyntaxHighlighter/
                    */
                    // An array of the available modes for you plugin.
                    // The key corresponds to the string shown in the select tag.
                    // The value correspond to the loaded file for ACE Editor.
                    modes: [
                        // Lavet ved at køre dette mod git fillisten i Firefox console: var s= "";var h = function(l){var ll = l.replace(/c_cpp/,"C++").replace(/csharp/,'C#');return ll;}; document.querySelectorAll("[data-qa-selector=file_name_link] > span:nth-child(2)").forEach(x => {if(x.innerText.startsWith("mode-")){ var lang = x.innerText.replace(/^mode\-|\.js$/g,'');s+=(s.length==0?'':',')+'["'+h(lang).toUpperCase()+'","'+lang+'"]'}}); console.log(s)
                        ["ABAP", "abap"], ["ABC", "abc"], ["ACTIONSCRIPT", "actionscript"], ["ADA", "ada"], ["APACHE_CONF", "apache_conf"], ["APPLESCRIPT", "applescript"], ["ASCIIDOC", "asciidoc"], ["ASSEMBLY_X86", "assembly_x86"], ["AUTOHOTKEY", "autohotkey"], ["BATCHFILE", "batchfile"], ["C9SEARCH", "c9search"], ["C++", "c_cpp"], ["CIRRU", "cirru"], ["CLOJURE", "clojure"], ["COBOL", "cobol"], ["COFFEE", "coffee"], ["COLDFUSION", "coldfusion"], ["C#", "csharp"], ["CSS", "css"], ["CURLY", "curly"], ["D", "d"], ["DART", "dart"], ["DIFF", "diff"], ["DJANGO", "django"], ["DOCKERFILE", "dockerfile"], ["DOT", "dot"], ["EIFFEL", "eiffel"], ["EJS", "ejs"], ["ELIXIR", "elixir"], ["ELM", "elm"], ["ERLANG", "erlang"], ["FORTH", "forth"], ["FTL", "ftl"], ["GCODE", "gcode"], ["GHERKIN", "gherkin"], ["GITIGNORE", "gitignore"], ["GLSL", "glsl"], ["GOLANG", "golang"], ["GROOVY", "groovy"], ["HAML", "haml"], ["HANDLEBARS", "handlebars"], ["HASKELL", "haskell"], ["HAXE", "haxe"], ["HTML", "html"], ["HTML_ELIXIR", "html_elixir"], ["HTML_RUBY", "html_ruby"], ["INI", "ini"], ["IO", "io"], ["JACK", "jack"], ["JADE", "jade"], ["JAVA", "java"], ["JAVASCRIPT", "javascript"], ["JSON", "json"], ["JSONIQ", "jsoniq"], ["JSP", "jsp"], ["JSX", "jsx"], ["JULIA", "julia"], ["LATEX", "latex"], ["LEAN", "lean"], ["LESS", "less"], ["LIQUID", "liquid"], ["LISP", "lisp"], ["LIVE_SCRIPT", "live_script"], ["LIVESCRIPT", "livescript"], ["LOGIQL", "logiql"], ["LSL", "lsl"], ["LUA", "lua"], ["LUAPAGE", "luapage"], ["LUCENE", "lucene"], ["MAKEFILE", "makefile"], ["MARKDOWN", "markdown"], ["MASK", "mask"], ["MATLAB", "matlab"], ["MAZE", "maze"], ["MEL", "mel"], ["MIPS_ASSEMBLER", "mips_assembler"], ["MIPSASSEMBLER", "mipsassembler"], ["MUSHCODE", "mushcode"], ["MYSQL", "mysql"], ["NIX", "nix"], ["OBJECTIVEC", "objectivec"], ["OCAML", "ocaml"], ["PASCAL", "pascal"], ["PERL", "perl"], ["PGSQL", "pgsql"], ["PHP", "php"], ["PLAIN_TEXT", "plain_text"], ["POWERSHELL", "powershell"], ["PRAAT", "praat"], ["PROLOG", "prolog"], ["PROPERTIES", "properties"], ["PROTOBUF", "protobuf"], ["PYTHON", "python"], ["R", "r"], ["RDOC", "rdoc"], ["RHTML", "rhtml"], ["RUBY", "ruby"], ["RUST", "rust"], ["SASS", "sass"], ["SCAD", "scad"], ["SCALA", "scala"], ["SCHEME", "scheme"], ["SCSS", "scss"], ["SH", "sh"], ["SJS", "sjs"], ["SMARTY", "smarty"], ["SNIPPETS", "snippets"], ["SOY_TEMPLATE", "soy_template"], ["SPACE", "space"], ["SQL", "sql"], ["SQLSERVER", "sqlserver"], ["STYLUS", "stylus"], ["SVG", "svg"], ["SWIFT", "swift"], ["SWIG", "swig"], ["TCL", "tcl"], ["TEX", "tex"], ["TEXT", "text"], ["TEXTILE", "textile"], ["TOML", "toml"], ["TWIG", "twig"], ["TYPESCRIPT", "typescript"], ["VALA", "vala"], ["VBSCRIPT", "vbscript"], ["VELOCITY", "velocity"], ["VERILOG", "verilog"], ["VHDL", "vhdl"], ["XML", "xml"], ["XQUERY", "xquery"], ["YAML", "yaml"]
                    ],

                    // The theme of the ACE Editor of the plugin.
                    theme: 'textmate',

                    // Tab indentation (in spaces)
                    tab_size: '4'
                }
            }}
            initData={p.initialText}
                
            onBeforeLoad={
                CKEDITOR => {
                    CKEDITOR.plugins.addExternal('pbckcode',"https://cdn.arcanic.dk/cdn/system/arcanic-editor/ckeditor/plugins/pbckcode/", "plugin.js");
                    CKEDITOR.plugins.addExternal('mathjax',"https://cdn.arcanic.dk/cdn/system/arcanic-editor/ckeditor/plugins/mathjax/", "plugin.js");
                }
            }
            onChange={onChange}
            editorUrl="https://cdn.arcanic.dk/cdn/libs/ckeditor/4.17.2-full/ckeditor.js"
            style={{ height: "100%" }}

            />
        </CKEditorCSSHack>
    );
});

export default Editor;